import { render } from "./PsDropdown.vue?vue&type=template&id=83f4f2d2&ts=true"
import script from "./PsDropdown.vue?vue&type=script&lang=ts"
export * from "./PsDropdown.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__